import React from "react";
import { Desktop } from "../containers/common";
import { Switch, Route, useRouteMatch } from "react-router-dom";

//screens

import {
  SpinTheWheelHome,
  InfoPage,
  VoucherRedemption,
  AirtimeRedemption,
  DataRedemption,
  HistoryPage,
  Orders,
  PointsBuildingRules,
  Leaderboard,
} from "../screens/subscriber/spinTheWheel";
import SpinTheWheelOrderDetails from "../screens/subscriber/spinTheWheel/pages/OrderDetails";
import RedemptionOnground from "../screens/subscriber/spinTheWheel/pages/RedemptionOnground";

const SpinTheWheel = () => {
  const match = useRouteMatch();
  return (
    <>
      <Desktop phonebg={"white"}>
        <Switch>
          <Route path={`${match.path}/info_page`} render={() => <InfoPage />} />
          <Route
            path={`${match.path}/voucher_redemption`}
            render={() => <VoucherRedemption />}
          />
          <Route
            path={`${match.path}/airtime_redemption`}
            render={() => <AirtimeRedemption />}
          />
          <Route
            path={`${match.path}/data_redemption`}
            render={() => <DataRedemption />}
          />
          <Route
            path={`${match.path}/history`}
            render={() => <HistoryPage />}
          />
          <Route path={`${match.path}/orders`} render={() => <Orders />} />
          <Route
            path={`${match.path}/order_details`}
            render={() => <SpinTheWheelOrderDetails />}
          />
          <Route
            path={`${match.path}/redeem`}
            render={() => <RedemptionOnground />}
          />
          <Route
            path={`${match.path}/rules`}
            render={() => <PointsBuildingRules />}
          />
          <Route
            path={`${match.path}/leaderboard`}
            render={() => <Leaderboard />}
          />
          <Route
            path={`${match.path}/home`}
            render={() => <SpinTheWheelHome />}
          />
          <Route
            path={`${match.path}`}
            render={() => <PointsBuildingRules />}
          />
        </Switch>
      </Desktop>
    </>
  );
};

export default SpinTheWheel;
